import { Box } from "@repo/components/src/ui/box";
import { Card } from "@repo/components/src/ui/card";
import { HStack } from "@repo/components/src/ui/hstack";
import { Text } from "@repo/components/src/ui/text";
import { VStack } from "@repo/components/src/ui/vstack";
import { formatPercentage } from "@repo/components/src/utils/numbers";
import { CampaignAnalyticFragmentFragment } from "@repo/graphql/documents/campaign/fragment.generated";
import React from "react";

type Props = {
  report: CampaignAnalyticFragmentFragment;
};

const ProductionHealth = React.memo(({ report }: Props) => {
  const {
    totalCount: total,
    finishedCount: finished,
    inProgressCount: inProgress,
    cancelledCount: cancelled,
    rejectedCount: rejected,
    avgRevisions,
  } = report.productionHealth;
  const cancelledOrRejected = cancelled + rejected;
  const pct = (n: number) => (total ? n / total : 0);

  return (
    <HStack className="flex-wrap -m-1.5">
      <StatCard
        label="ODTs Completadas"
        value={formatPercentage(pct(finished))}
        sub={`${finished} de ${total} órdenes finalizadas`}
      />
      <StatCard
        label="ODTs en Curso"
        value={formatPercentage(pct(inProgress))}
        sub={`${inProgress} órdenes en curso`}
      />
      <StatCard
        label="ODTs Canceladas y Rechazadas"
        value={formatPercentage(pct(cancelledOrRejected))}
        sub={`${cancelled} canceladas · ${rejected} rechazadas`}
      />
      <StatCard
        label="Promedio de Revisiones"
        value={avgRevisions.toFixed(1)}
        sub="Entregas hasta aprobarse"
      />
    </HStack>
  );
});

ProductionHealth.displayName = "UgcProductionHealth";

const StatCard = ({
  label,
  value,
  sub,
}: {
  label: string;
  value: string;
  sub: string;
}) => (
  <Box className="w-1/4 p-1.5">
    <Card variant="outline" size="md" className="rounded-xl h-full">
      <VStack space="xs" className="h-full">
        <Text size="xs" className="text-typography-500 uppercase font-semibold">
          {label}
        </Text>
        <Text size="3xl" className="font-bold text-typography-900">
          {value}
        </Text>
        <Text size="xs" className="text-typography-500">
          {sub}
        </Text>
      </VStack>
    </Card>
  </Box>
);

export default ProductionHealth;
